import { render, staticRenderFns } from "./MyAccreditationsLoading.vue?vue&type=template&id=24091717&"
import script from "./MyAccreditationsLoading.ts?vue&type=script&lang=ts&"
export * from "./MyAccreditationsLoading.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports